import React, { useState } from "react";
import { produce } from "immer";
import Input from "../../../Input";
import { nanoid } from "nanoid";
import { RiCloseLine } from "react-icons/ri";
import Select, { OptionProps } from 'react-select';
const DIAMETER_COUNT = 4;

// The four diameters are packed into the item's `dimension` string ("95x80x85x90"),
// since the API stores Dimension as free text. Legacy records kept diameter 1 in
// `dimension` and diameter 2 in `width`, so fall back to those when unpacking.
const getDiameters = (p) => {
  const parts = String(p.dimension ?? "").split("x");
  if (parts.length > 1) {
    return Array.from({ length: DIAMETER_COUNT }, (_, i) => (parts[i] ?? "").trim());
  }
  return [parts[0] ?? "", p.width ? String(p.width) : "", "", ""];
};

const TreeFellItems = (props) => {
  return (
    <div className="w-full">
      {props.treeFellItems.map((p, index) => {
        return (
          <div className="flex flex-wrap items-end gap-3" key={p.id}>
            <label className="block">
              <span className="block mb-3 text-gray-700 text-md">
                Species
              </span>
              <Select

                        id={index}
                          // className="ot-s" 
                          options={props.trees}
                          value={p.tree}
                          name="treeId"
                          defaultValue={p.tree}
                          // onChange={(evnt)=>(handleSelectChange(index, evnt))}
                          
                          onChange={(e) => {
                            const tree = e;
                            console.log(e);
                            props.setTreeFellItems((currentTreeFellItems) =>
                              produce(currentTreeFellItems, (v) => {
                                v[index].tree = tree;
                                v[index].treeId = tree.treeId;
                              })
                            );
                          }}
                          menuPlacement="auto" menuPosition="fixed" placeholder="Tree"  className="treeSelect" />
              
            </label>
            <label className="block">
              <span className="block mb-3 text-gray-700 text-md">
                Stock Number
              </span>
              <Input
                onChange={(e) => {
                  const description = e.target.value;
                  props.setTreeFellItems((currentTreeFellItems) =>
                    produce(currentTreeFellItems, (v) => {
                      v[index].description = description;
                    })
                  );
                }}
                value={p.description}
                // placeholder="Description"
              />
            </label>
            {getDiameters(p).map((diameter, dIndex) => (
              <label className="block" key={dIndex}>
                <span className="block mb-3 text-gray-700 text-md">
                  Diameter {dIndex + 1}(cm)
                </span>
                <Input
                  onChange={(e) => {
                    const value = e.target.value;
                    props.setTreeFellItems((currentTreeFellItems) =>
                      produce(currentTreeFellItems, (v) => {
                        const diameters = getDiameters(v[index]);
                        diameters[dIndex] = value;
                        // packed string + width for the current API; diameter1-4 for the
                        // upcoming backend contract (extra props are ignored until it deploys)
                        v[index].dimension = diameters.join("x");
                        v[index].width = parseInt(diameters[1]) || 0;
                        v[index].diameter1 = parseFloat(diameters[0]) || 0;
                        v[index].diameter2 = parseFloat(diameters[1]) || 0;
                        v[index].diameter3 = parseFloat(diameters[2]) || 0;
                        v[index].diameter4 = parseFloat(diameters[3]) || 0;
                      })
                    );
                  }}
                  value={diameter}
                />
              </label>
            ))}
            <label className="block">
              <span className="block mb-3 text-gray-700 text-md">Length(cm)</span>
              <Input
                onChange={(e) => {
                  const length = e.target.value;
                  props.setTreeFellItems((currentTreeFellItems) =>
                    produce(currentTreeFellItems, (v) => {
                      v[index].length = parseInt(length);
                    })
                  );
                }}
                value={p.length}
                // placeholder="Volume"
              />
            </label>
            <label className="block">
              <span className="block mb-3 text-gray-700 text-md">Volume(&#13220;)</span>
              <Input
                onChange={(e) => {
                  const volume = e.target.value;
                  props.setTreeFellItems((currentTreeFellItems) =>
                    produce(currentTreeFellItems, (v) => {
                      v[index].volume = parseInt(volume);
                    })
                  );
                }}
                value={p.volume}
                // placeholder="Volume"
              />
            </label>
            <button
              className="flex items-center justify-center text-lg text-white bg-red-500 rounded rounded-full w-7 h-7"
              onClick={(e) => {
                e.preventDefault();
                if(p.treeFellItemId){
                  
                  props.deleteAction(p.treeFellItemId)
                }else{
                  props.setTreeFellItems((currentTreeFellItems) =>
                  currentTreeFellItems.filter((x) => x.id !== p.id)
                );
                }
                
              }}
            >
              <RiCloseLine />
            </button>
          </div>
        );
      })}
      <button
        className="self-end w-auto px-2 py-1 my-3 font-semibold text-white rounded rounded-md sm:px-3 bg-tclPrimary/75"
        onClick={(e) => {
          e.preventDefault();
          props.setTreeFellItems((currentTreeFellItems) => [
            ...currentTreeFellItems,
            {
              description: "",
              dimension: "",
              quantity: 1,
              volume: 0,
              width: 0,
              length: 0,
              tree:'',
              treeId:0,
              id: nanoid(),
            },
          ]);
        }}
      >
        Add Item
      </button>
      {/* <div>{JSON.stringify(treeFellItems, null, 2)}</div> */}
    </div>
  );
};

export default TreeFellItems;
